module.exports = __webpack_public_path__ + "img/grade-7.7d9f5c5e.png";